import { SVGProps } from "react-html-props";
import { motion } from "motion/react";
import { classes } from "lib/actions/util";

/**
 * Nav icon inside a fixed tile. When `isActive`, a raised white tile sits
 * behind the icon and the icon takes `activeColorClassName`; otherwise it
 * inherits the item's text colour.
 *
 * Items sharing a `group` share one tile, so it slides between them when the
 * selection moves within the group.
 */
export default function SideNavItemIcon(p: {
  svg: React.FC<SVGProps>;
  isActive?: boolean;
  activeColorClassName?: string;
  group?: string;
}) {
  return (
    <span
      className={classes(
        "relative mx-3 flex h-10 w-10 shrink-0 items-center justify-center",
        p.isActive && p.activeColorClassName,
      )}
    >
      {p.isActive && (
        <motion.span
          layoutId={p.group ? `side-nav-tile-${p.group}` : undefined}
          className="absolute inset-0 rounded-lg bg-white shadow-1"
          transition={{ type: "spring", bounce: 0.15, duration: 0.35 }}
        />
      )}
      <p.svg className="relative h-6 w-6" />
    </span>
  );
}
